import { RootState } from '@app/redux/types';
import { isBrowser } from '@app/utils';

const attachInitialStateToWindow = (state: RootState) => {
  if (isBrowser) {
    window.__INITIAL_REDUX_STATE__ = state;
  }
};

export default attachInitialStateToWindow;
